import React from 'react';
import { CleanUser } from '../../export-types/cleaned-types';
import { FormattedMessage } from 'react-intl';
import { ClientRequestInfoActions } from './client-request-info-actions';
import { KeyedMutator } from 'swr';

type ClientInfoProps = {
  user: CleanUser;
  mutate?: KeyedMutator<any>;
};

export const ClientInfo: React.FC<ClientInfoProps> = (props) => {
  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <div className="fs-18 fw-600 color-gray-450">
          <FormattedMessage
            defaultMessage="Клиент"
            id="clientInfo.label.customer"
            description="Заголовок на странице"
          />
        </div>
        <ClientRequestInfoActions user={props.user} mutate={props.mutate} />
      </div>

      <div className="d-flex flex-row">
        <div className="pe-3">
          <div
            className="bi bi-person-circle color-gray-600 lh-1"
            style={{ fontSize: 50 }}
          />
        </div>
        <div>
          <div className="fs-16 fw-500">
            {[props.user.name, props.user.internalId]
              .filter((item) => item)
              .join(', ')}
          </div>
          {props.user.phone && (
            <div className="color-gray-400">{props.user.phone}</div>
          )}
          {props.user.email && (
            <div className="color-gray-400">{props.user.email}</div>
          )}
        </div>
      </div>
      <div className="mt-3">
        <div>
          <FormattedMessage
            defaultMessage="Основной менеджер: {value}"
            id="clientInfo.label.primaryManager"
            description="Основной менеджер клиента"
            values={{ value: props.user.manager?.name ?? '-' }}
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="Наблюдатели: {value}"
            id="clientInfo.label.observers"
            description="Наблюдатели клиента"
            values={{
              value:
                props.user.observers
                  ?.map((item) => item.name)
                  .filter(Boolean)
                  .join(', ') || '-',
            }}
          />
        </div>
      </div>
    </div>
  );
};
